export enum DiscountCategory {
  PERIOD = '기간별 할인',
  PERSONAL = '개인별 할인',
  EVENT = '이벤트 할인',
}

export enum DiscountSubCategory {
  // 기간별 할인
  EARLY_BIRD = '얼리버드 할인',

  // 개인 추천 할인
  PLUS_GRADUATE = '플러스 수료생 추천 할인',
  COACH = '코치 추천 할인',
  INFLUENCER = '인플루언서 추천 할인',

  // 이벤트 할인
  ORIENTATION = '설명회 할인',
  DEVLAB = '데브랩 할인',
  LAUNCH = '론칭 기념 할인',
  SPECIAL_EVENT = '특별 이벤트 할인',
}
export interface ValidateDiscountCodeRequestDto {
  courseName: string;
  code: string;
  onlineUserId: string;
}

export interface LegacyDiscountPolicyInApplicantBill {
  courses: string[];
  createdAt: string;
  discountAmount: number;
  incentiveAmount: number;
  isDuplicateAllowed: boolean;
  name: string;
  updatedAt: string;
  _id: string;
}

export interface DiscountPolicy {
  _id: string;
  category: DiscountCategory;
  subCategory: DiscountSubCategory;
  discountName: string;
  exposedName: string; // Detail에서 보여야할 할인명
  discountAmount: number;
  discountStartDate: string;
  discountEndDate: string;
}

export interface DiscountCode extends DiscountPolicy {
  discountCodeId: string;
}

export interface ValidateDiscountCodeSuccessResponseDto extends DiscountCode {}

export interface EarlybirdDiscountResponseDto extends DiscountPolicy {}

export type EnrolledDiscountCode = {
  code: string; // "m21jyy"
  createdAt: string; // "2025-06-02T14:25:09.548Z"
  discountPolicy: DiscountPolicy; // {_id: '6881d2fa9fd12e86870da959', category: '개인별 할인', subCategory: '플러스 수료생 추천 할인', courses: Array(2), discountName: '플러스 수료생 추천 할인', …}
  name: string; // "오유진"
  onlineUserId: string; // "6438df3f8420cf725ecc55da"
  phone: string; // "01077423767"
  updatedAt: string; // "2025-06-02T14:25:09.548Z"
  _id: string; // "683d35b519c42c21b342aed3"
};

export type EnrolledDiscountCodesResponseDto = EnrolledDiscountCode | undefined;
